/**
 * Controls visibility of the "Project Settings → Source Repository" entry in the
 * designer's Configurations panel.
 *
 * Reads from window._env_.SOURCE_REPOSITORY_VISIBLE (emitted by env.sh at
 * container start; see designer/env.sh and public/env-config.js):
 * - absent / null / empty                          → HIDDEN (default; opt-in)
 * - "false" (case-insensitive)                     → HIDDEN (explicit off)
 * - any other non-empty value (e.g. "true")        → VISIBLE
 *
 * OPT-IN semantics: the source-repository push UI ships hidden everywhere and is
 * turned on only where a deployment explicitly sets the env var (SOURCE_REPOSITORY_VISIBLE=true).
 * This is a FRONTEND-ONLY gate — the backend/codegen and the ProjectSettings APIs are
 * untouched; only the UI entry point is shown/hidden. The deployment's env var
 * regenerates env-config.js on container boot (env.sh), so it toggles without a rebuild.
 */
export function isSourceRepositoryVisible(): boolean {
  // window._env_ is globally typed in src/global.d.ts (KuikaWindowEnv).
  const raw: string | undefined = window._env_?.SOURCE_REPOSITORY_VISIBLE;
  if (raw === undefined || raw === null || raw.trim() === "") return false;
  return raw.trim().toLowerCase() !== "false";
}
